import React from "react";
import {
  FaUniversity,
  FaCreditCard,
  FaCalendarAlt,
  FaBarcode,
  FaMapMarkerAlt,
  FaCity,
  FaGlobe,
  FaMapPin,
} from "react-icons/fa";
import "./BankView.css";

const BankView = ({ currentRecord }) => {
  if (!currentRecord) {
    return <div>Loading...</div>;
  }

  const dateOfOpening = currentRecord.date_of_opening ? new Date(currentRecord.date_of_opening) : null;

  return (
    <div className="bank-view-container">
      <div className="bank-header">
        <FaUniversity size={24} />
        <h2>{currentRecord?.bank_name || 'N/A'}</h2>
      </div>
      <div className="bank-details">
        <div className="details-section">
          <h3>Account Information</h3>
          <p className="detail-item">
            <FaCreditCard />
            <strong>Account Number:</strong> {currentRecord?.account_number || 'N/A'}
          </p>
          <p className="detail-item">
            <FaCreditCard />
            <strong>Account Type:</strong> {currentRecord?.account_type || 'N/A'}
          </p>
          <p className="detail-item">
            <FaCalendarAlt />
            <strong>Date of Opening:</strong>{" "}
            {dateOfOpening ? new Intl.DateTimeFormat("en-US", {
              year: "numeric",
              month: "long",
              day: "2-digit",
            }).format(dateOfOpening) : 'N/A'}
          </p>
        </div>

        <div className="details-section">
          <h3>Bank Details</h3>
          <p className="detail-item">
            <FaBarcode />
            <strong>Routing Number:</strong> {currentRecord?.routing_number || 'N/A'}
          </p>
          <p className="detail-item">
            <FaBarcode />
            <strong>Swift Code:</strong> {currentRecord?.swift_code || 'N/A'}
          </p>
        </div>

        <div className="details-section">
          <h3>Location Information</h3>
          <p className="detail-item">
            <FaMapMarkerAlt />
            <strong>Street:</strong> {currentRecord?.bank_address || 'N/A'}
          </p>
          <p className="detail-item">
            <FaCity />
            <strong>City:</strong> {currentRecord?.city?.label || 'N/A'}
          </p>
          <p className="detail-item">
            <FaMapPin />
            <strong>State:</strong> {currentRecord?.state?.label || 'N/A'}
          </p>
          <p className="detail-item">
            <FaGlobe />
            <strong>Country:</strong> {currentRecord?.country?.label || 'N/A'}
          </p>
          <p className="detail-item">
            <FaMapPin />
            <strong>ZIP Code:</strong> {currentRecord?.bank_zipcode || 'N/A'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default BankView;
